import doRequest from "./index";
import { baseUrl, googleMapKey } from "../common/Constant";

const GlobalService = {
    getLang: lng => {
        // const baseUrl = process.env.BASE_URL;
        return doRequest("get", `/locales/${lng}.json`);
    },
    // Forgot Password Api
    forgotPassRequest: (lang, user) => {
        return doRequest(
            "post",
            `${baseUrl}${forgotPassURL}?language=${lang}&user=${user}`, {}, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                }
            }
        );
    },
    // a function to get user menus list
    getBoxesForMap: (token) => {
        return doRequest(
            "get",
            `${baseUrl}getdealersystems.php?token=${token}`
        );
    },
    getUserInfo: (token) => {
        return doRequest(
            "get",
            `${baseUrl}getdealerinfo.php?token=${token}`
        );
    },
    getEventsList: (sysId, token, offset, count) => {
        return doRequest(
            "get",
            `${baseUrl}getevents.php?systemid=${sysId}&token=${token}&offset=${offset}&count=${count}`
        );
    },
    alarmButton: (token, systemId, action) => {
        return doRequest(
            "get",
            `${baseUrl}buttonpush.php?token=${token}&systemid=${systemId}&action=${action}`
        );
    },

    getDealerInfo: (token) => {
      return doRequest(
        "get",
        `${baseUrl}getdealerinfo.php?token=${token}`
      );
    },
    getDealerSystems: (token) => {
        return doRequest(
            "get",
            `${baseUrl}getdealersystems.php?token=${token}`
        );
    },
    getUserToken: (token, userid) => {
      return doRequest(
        "get",
        `${baseUrl}getusertoken.php?token=${token}&userid=${userid}`,
      );
    },

    getDealerDashboard: (token) => {
      return doRequest(
          "get",
          `${baseUrl}getdealerdashinfo.php?token=${token}`
      );
    },
    // Employee CRUD
    getEmployeesList: (token) => {
      return doRequest(
          "get",
          `${baseUrl}getdealeremployees.php?token=${token}`
      );
    },
    addNewEmployee: (token, name) => {
      return doRequest(
          "get",
          `${baseUrl}adddealeremployee.php?token=${token}&name=${name}`,
      );
    },
    deleteEmployee: (token, employeeid) => {
      return doRequest(
          "get",
          `${baseUrl}deletedealeremployee.php?token=${token}&employeeid=${employeeid}`,
      );
    },

    assignEmployeeToSystem: (token, sysId, empId) => {
      return doRequest(
          "get",
          `${baseUrl}assigndealeremployee.php?token=${token}&systemid=${sysId}&employeeid=${empId}`
      );
    },

    // admin apis
    getAdminDealers: (token) => {
      return doRequest(
          "get",
          `${baseUrl}getadmindealers.php?token=${token}`
      );
    },
    getDealerToken: (token, dealerid) => {
      return doRequest(
          "get",
          `${baseUrl}getadmintoken.php?token=${token}&dealerid=${dealerid}`
      );
    },
    getDealersForSystem: (token, systemid) => {
      return doRequest(
          "get",
          `${baseUrl}getdealersforsystem.php?token=${token}&systemid=${systemid}`
      );
    },
    assignDealerToSystem: (token, dealerid, systemid) => {
      return doRequest(
          "get",
          `${baseUrl}addsystemtodealer.php?token=${token}&dealerid=${dealerid}&systemid=${systemid}`
      );
    },
    removeDealerFromSystem: (token, dealerid, systemid) => {
      return doRequest(
          "get",
          `${baseUrl}removesystemfromdealer.php?token=${token}&dealerid=${dealerid}&systemid=${systemid}`
      );
    },
    getdealerinfo: (token) => {
      return doRequest(
          "get",
          `${baseUrl}getdealerinfo.php?token=${token}`
      );
    },

    // dealer specific apis
    getDealerDealers: (token, dealerId) => {
      return doRequest(
          "get",
          `${baseUrl}getdealerdealers.php?token=${token}&dealerid=${dealerId}`
      );
    },

    //reset service Date for system
    resetServiceDate: (token, systemId, servicedate="now", modifyonly=false) => {
      return doRequest(
          "get",
          `${baseUrl}editservice.php?token=${token}&systemid=${systemId}&servicedate=${servicedate}&modifyonly=${modifyonly}`
      );
    },

    //assign system to dealer
    assignSystemItselfDealer: (token, boxId, boxPass) => {
      return doRequest(
          "get",
          `${baseUrl}assignsystemtodealer.php?token=${token}&sewerboxid=${boxId}&sewerboxpass=${boxPass}`
      );
    },
};

export default GlobalService;